import { gridStoreResults } from 'fox-react/dist/components/FoxGrid/actions';
import gridNames from 'common/gridNames';
import CarsSrv from './CarsSrv';

export function storeResults(results) {
  return gridStoreResults(gridNames.cars)(results);
}

export function getForGrid(dataState) {
  return function(dispatch) {
    return CarsSrv.getForGrid(dataState).then(results => {
      dispatch(storeResults(results));
    });
  };
}
